import { useMemo } from 'react';

import {
  EmployeeItemInfoData,
  useEmployeeItemInfo,
} from '~/components/GenericList/EmployeeItemInfo';

type PropsType = {
  employeeIds: number[];
  selectedEmployeeId?: number;
};

type Results = {
  options: EmployeeItemInfoData[];
  employees: EmployeeItemInfoData[];
  selected?: EmployeeItemInfoData;
};

export const useEmployeeSelect = (props: PropsType) => {
  const { employeeIds, selectedEmployeeId } = props;
  const { getEmployeeItemInfoById, getEmployeeItemInfoByIds } =
    useEmployeeItemInfo();

  const results = useMemo(() => {
    const empIds: number[] = (
      !!selectedEmployeeId ? [...employeeIds, selectedEmployeeId] : employeeIds
    ).filter((e, i, a) => a.indexOf(e) === i);

    return getEmployeeItemInfoByIds(empIds).reduce(
      (acc: Results, agent: EmployeeItemInfoData) => {
        const agentId = agent.employeeId;

        return {
          options: employeeIds.includes(agentId)
            ? [...acc.options, agent]
            : acc.options,
          employees: [...acc.employees, agent],
          selected: selectedEmployeeId === agentId ? agent : undefined,
        };
      },
      { options: [], employees: [], selected: undefined },
    );
  }, [employeeIds, selectedEmployeeId, getEmployeeItemInfoByIds]);

  return {
    ...results,
    getSelected: getEmployeeItemInfoById,
  };
};
